import React from 'react';
import PropTypes from 'prop-types';

import exportWithBoundary from '../../../helpers/exportWithBoundary';
import Tooltip from '../../Tooltip';
import { BadgeContainer, BadgeText } from './styles';

function Badge(props) {
  // eslint-disable-next-line no-unused-vars
  const { text, icon, color, size, badgeStyle, className, tipText, onClick } =
    props;
  const iconSizeClass = `icon--${size === 'sm' ? 16 : 20}`;

  const badge = (
    <BadgeContainer className={className} onClick={onClick} {...props}>
      {icon && (
        <i
          className={`icon-${icon} ${iconSizeClass} ${
            text !== null ? 'mr-1' : ''
          }`}
        />
      )}
      {text && <BadgeText>{text}</BadgeText>}
    </BadgeContainer>
  );

  return tipText ? <Tooltip tipText={tipText}>{badge}</Tooltip> : <>{badge}</>;
}

Badge.defaultProps = {
  text: null,
  icon: null,
  color: 'neutral',
  size: null,
  badgeStyle: null,
  className: null,
  tipText: null,
  onClick: null,
};

Badge.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string,
  badgeStyle: PropTypes.string,
  className: PropTypes.string,
  tipText: PropTypes.string,
  onClick: PropTypes.func,
};

function BadgeFallback() {
  return <BadgeContainer />;
}

export default exportWithBoundary(Badge, BadgeFallback);
